import { createFileRoute } from '@tanstack/react-router'
import { UserTrash } from '@components'

export const Route = createFileRoute('/user_/trash/')({
  component: () => <UserTrash />,
})
